'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/is-pure.js
// module id = 520
// module chunks = 0